import { createAction, createReducer } from "@reduxjs/toolkit";

export const resetUserTokenAction = createAction("app/resetUserTokenAction");
export const storeUser = createAction("app/storeUser");
export const storeToken = createAction("app/storeToken");
export const addToCart = createAction("cart/addToCart");
export const removeFromCart = createAction("cart/removeFromCart");
export const updateCart = createAction("cart/updateCart");
export const deleteCart = createAction("cart/deleteCart");
export const clearCart = createAction("cart/clearCart");
export const setCart = createAction("cart/setCart");
export const storeManufacturers = createAction("app/storeManufacturers");
export const storeCategories = createAction("app/storeCategories");
export const storeSettings = createAction("app/storeSettings");
export const setBootstrapDone = createAction("app/setBootstrapDone");
export const resetBootstrap = createAction("app/resetBootstrap");
export const appReducer = createReducer(
  {
    token: null,
    user: null,
    tokenExpired: null,
    cart: [],
    manufacturers: [],
    categories: [],
    bootstrapDone: false,
  },
  {
    [storeUser]: (state, action) =>
      (state = { ...state, user: action.payload }),
    [storeManufacturers]: (state, action) =>
      (state = { ...state, manufacturers: action.payload }),
    [storeCategories]: (state, action) =>
      (state = { ...state, categories: action.payload }),
    [storeSettings]: (state, action) =>
      (state = { ...state, settings: action.payload }),
    [setBootstrapDone]: (state, action) =>
      (state = { ...state, bootstrapDone: true }),
    [resetBootstrap]: (state, action) =>
      (state = { ...state, bootstrapDone: false }),
    [storeToken]: (state, action) =>
      (state = { ...state, token: action.payload }),
    [resetUserTokenAction]: (state, action) =>
      (state = { ...state, token: action.payload, user: action.payload }),
      [addToCart]: (state, action) => {
        state.cart.push(action.payload);
      },
    
      [removeFromCart]: (state, action) => {
        state.cart = state.cart.filter((item, i) => i !== action.payload);
      },
    
      [updateCart]: (state, action) => {
        const { index, product } = action.payload;
        state.cart[index] = product;
      },
    
      [deleteCart]: (state, action) => {
        state.cart = state.cart.filter((item, i) => i !== action.payload);
      },
    
      [clearCart]: (state) => {
        state.cart = [];
      },
    
      [setCart]: (state, action) => {
        state.cart = action.payload;
      }
  }
);
